import React from "react";
import { Row, Col, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { getSession, getCurrentAccount, getSavedPersonInfo, getTexts } from "../../reducers/selectors";
import icon from "../../../public/svg/i.svg";
import { Link } from "react-router-dom";

import style from "./InvestorProfile.scss";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";

export const InvestorProfile = () => {
  const currentAccount = useSelector(getCurrentAccount);
  const personInfo = useSelector(getSavedPersonInfo);
  const texts = useSelector(getTexts);

  const profileRiskString = {
    Conservative: "Conservador",
    Moderate: "Moderado",
    Aggressive: "Agresivo",
    Aggresive: "Agresivo",
  };

  const profileRiskDescriptionString = {
    Conservative: texts.notes.investor_profile_conservative,
    Moderate: texts.notes.investor_profile_moderate,
    Aggressive: texts.notes.investor_profile_aggressive,
    Aggresive: texts.notes.investor_profile_aggressive,
  };

  if (!personInfo) return <CircularProgress />;

  return (
    <Col className={style.wrapperCol} lg="12">
      <div className={style.title}>Perfil inversor</div>

      <div className={style.container}>
        <div>tú perfil de inversionista es</div>
        <div>{profileRiskString[personInfo.PersonProfileRiskName]}</div>
        <div>{profileRiskDescriptionString[personInfo.PersonProfileRiskName]}</div>

        <Link to="/investorProfile/profileTestAnswer">
          <Button className={style.orangeButton}>ver respuestas de prueba de perfil</Button>
        </Link>
        <img className={style.icon} src={icon} alt="icon" />
        <br></br>
        <Link to="/investorProfile/profileTest">
          <Button className={style.blueButton}>rehacer prueba de perfil</Button>
        </Link>
        <br></br>
        <Link to="/investorProfile/accountProfileTest">
          <Button className={style.orangeButton}>ver respuestas de perfil de la cuenta</Button>
        </Link>
        <img className={style.icon} src={icon} alt="icon" />
      </div>
    </Col>
  );
};
